const NoDataFound = ({colSpan,message}) => {
    return (
         <tr>
                    <td colSpan={colSpan} className="text-center py-5">
                      <div className="d-flex flex-column align-items-center" style={{ color: '#90a4ae' }}>
                        <div
                          className="mb-3 d-flex align-items-center justify-content-center rounded-circle"
                          style={{ width: 56, height: 56, background: '#f5f5f5' }}
                        >
                          <i className="bi bi-inbox" style={{ fontSize: 24, color: '#b0bec5' }}></i>
                        </div>
                        <span style={{ fontWeight: 600, fontSize: 14, color: '#78909c' }}>No Data Found</span>
                        <small style={{ color: '#b0bec5' }}>{message || "Add some data to see results"}</small>
                      </div>
                    </td>
                  </tr>
    );
}

export default NoDataFound;